import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import CardLayout from '@magoosh/layouts/card';
import { paths } from 'config/path_helpers';
import { PracticeSession } from 'types/practice_session';

import ContextualLink from '@test_prep/app/components/contextual_link';
import { useAppContext } from '@test_prep/app/context';
import { useQueries } from '@test_prep/app/queries';

import PracticeSessionsTable from './components/practice_sessions_table';

const ReviewPracticeSessions: React.FC<{}> = (props) => {
  const { branding } = useAppContext().data;
  const studentId = useParams().studentId ? parseInt(useParams().studentId) : null;
  const q = useQueries();
  const [practiceSessions, setPracticeSessions] = useState<PracticeSession[]>([]);

  const page = q.pageQuery(paths.reviewPracticeSessions()).data;

  return (
    <>
      <Helmet>
        <title>Review Practice Sessions - Magoosh {branding.examName}</title>
      </Helmet>

      <CardLayout
        linkComponent={ContextualLink}
        subnav={{
          title: 'Choose A Practice Session To Review',
          backLink: { path: paths.reviewAnswers(null, studentId), name: 'Back to review' }
        }}
      >
        <div className="d-flex flex-column gap-s gap-lg-m">
          <div className="align-items-end d-flex">
            <h3 className="flex-1 u-margin-A-n u-margin-T-s">
              <strong>Practice Sessions</strong>
            </h3>
          </div>

          <hr className="u-margin-A-n" />
        </div>

        <CardLayout.Card style={{ padding: 0 }}>
          <PracticeSessionsTable
            practiceSessions={practiceSessions}
            onChange={setPracticeSessions}
            studentId={studentId}
          />
        </CardLayout.Card>
      </CardLayout>
    </>
  );
};

export default ReviewPracticeSessions;
